import { envVars } from '@constants';
import { Api as BaseApi } from '@dotone/react-ui-core';

const Api = new BaseApi(envVars.appApiUrl);

export default Api;
